import Aegis from '@tencent/aegis-web-mini-sdk';
import qbjsapi from '@tencent/zixun-qbjsapi';

let globalAeigs = null;
export class AegisModule {
  constructor() {
    this.init();
  }

  async init() {
    if (globalAeigs) {
      return;
    }
    const browserParam = await qbjsapi.app.getBrowserParam();
    globalAeigs = new Aegis({
      id: 'cTTfdMjccujwmSGFXQ', // 项目ID，即上报id
      uin: browserParam.guid, // 用户唯一 ID（可选）
      reportApiSpeed: false, // 接口测速
      reportAssetSpeed: false, // 静态资源测速
    });
  }

  infoAll(msg) {
    globalAeigs && globalAeigs.infoAll(JSON.stringify(msg));
  }

  info(msg) {
    globalAeigs && globalAeigs.info(JSON.stringify(msg));
  }

  error(msg) {
    globalAeigs && globalAeigs.report(JSON.stringify(msg));
  }
}
